import { Cell, CelType, Row } from '../../data-table/data-table';

const generateRowHeader = (headers: string[]): Row => {
  return {
    cells: headers.map((header) => ({
      content: header,
      type: CelType.REGULAR,
    })) as Cell[],
  };
};

export default generateRowHeader;
